import React from 'react'
import {OptionsSelect} from './OptionsSelector.styles'

export function OptionsSelector({options, selectedValue, onChange}) {
  return (
    <OptionsSelect
      value={selectedValue ?? ''}
      onChange={e => {
        const found = options.find(o => o.value === e.target.value) ?? null
        onChange(found)
      }}
      onClick={e => e.stopPropagation()}
    >
      <option value="">Select option</option>
      {options.map(opt => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </OptionsSelect>
  )
}
